/**
 * Which scenarios a Mode's picker offers.
 *
 * Its own module, importing only the `Scenario` type, so it can be tested
 * without pulling in challenge.ts's chain of imports — chrome.ts among them,
 * which starts a live API request at import time. That is fine in the
 * browser and wrong in a test.
 */
import type { Scenario } from "../api";

/**
 * Which Mode card sent the player to the challenge screen.
 *
 * The only thing this changes today is the scenario pool: Duel narrows the
 * catalog to head-to-head scenarios (exactly two slots) before the picker is
 * built, Scenario shows all of it. Everything else on the challenge screen —
 * seats, opponents, camo — is identical either way.
 */
export type ChallengeMode = "duel" | "scenario";

/**
 * The scenarios a Mode's picker offers.
 *
 * A pure filter over the catalog `/api/scenarios` already returns — no new
 * curation, no new fields, and the Rust catalog untouched. Duel keeps only
 * head-to-head scenarios (exactly two slots, today: First Run, Final Exam,
 * Divide and Conquer); Scenario shows everything, four-slot Monte Diablo
 * included.
 */
export function scenarioPool(
  catalog: Scenario[],
  mode: ChallengeMode,
): Scenario[] {
  return mode === "duel"
    ? catalog.filter((entry) => entry.slots.length === 2)
    : catalog;
}
